// extracted by mini-css-extract-plugin
export default {"modalBody":"NutritionModal_modalBody__mNgb+","modalMultiButton":"NutritionModal_modalMultiButton__02DFL","inputs":"NutritionModal_inputs__3SP+k"};